import { HelpButtonModalProps } from './HelpModal.interface';
import { Modal } from '@axafr-btc-ds/modal';
import { Typography } from '@axafr-btc-ds/typography';
import { SecondaryButton } from '@axafr-btc-ds/buttons';
import { IfLayout } from '@axa-fr-axion/layouts';
import { convertPhoneNumber, PhoneNumber } from '@axa-fr-axion/utils';
import styles from './HelpModal.module.css';

export const HelpModal = ({ phoneNumber, isOpen, onClose, title }: HelpButtonModalProps): JSX.Element => {
    const agentPhoneNumber: PhoneNumber = convertPhoneNumber(phoneNumber);

    const handleClick = () => {
        window.location.href = agentPhoneNumber.href;
    };

    return (
        <Modal
            isContentReady={ true }
            isRounded={ true }
            isOpen={ isOpen }
            onClose={ onClose }
            title={ title }
            className={ styles.modal }
            describedBy='description'
            closeButtonAriaLabel='Fermer la fenêtre'
        >
            <div className={ styles.host }>
                <IfLayout>
                    <Typography
                        variant='body2'
                    >
                    Nos téléconseillers sont à votre écoute au :
                    </Typography>
                </IfLayout>
                <IfLayout className={ styles.actionContainer }>
                    <SecondaryButton
                        onClick={ handleClick }
                        className={ styles.action }
                        align='center'
                    >
                        { agentPhoneNumber.formatted }
                    </SecondaryButton>
                </IfLayout>
                <IfLayout>
                    <Typography
                        variant='body2'
                        id='description'
                    >Horaires : de 8h30 à 20h en semaine, samedi de 9h à 16h
                    (fermé le dimanche).
                    </Typography>
                </IfLayout>
            </div>
        </Modal>
    );
};
